import { useEffect, useRef, useState } from 'react';

type UsePollingOptions = {
  id: string | string[];
  query: () => Promise<unknown>;
  retry?: number;
  retryInterval?: number;

  // if false it will stop the polling
  enabled?: boolean;
};

export const usePolling = ({
  query,
  retry = 3,
  retryInterval = 1000, // in milliseconds,
  enabled = true,
}: UsePollingOptions) => {
  const timerIdRef = useRef<number | undefined>();
  const attemptsCounterRef = useRef<number>(0);
  const [isPollingEnabled, setIsPollingEnabled] = useState(true);
  const [result, setResult] = useState<any>(undefined);

  useEffect(() => {
    attemptsCounterRef.current = 0;
    setIsPollingEnabled(enabled);
    setResult(undefined);
  }, [enabled]);

  useEffect(() => {
    const pollingCallback = async () => {
      try {
        const result = await query();
        setResult(result);
        setIsPollingEnabled(false);
      } catch (error) {
        attemptsCounterRef.current += 1;
      } finally {
        if (attemptsCounterRef.current >= retry) {
          setIsPollingEnabled(false);
        }
      }
    };

    const startPolling = () => {
      // Polling every second
      timerIdRef.current = window.setInterval(pollingCallback, retryInterval);
    };

    const stopPolling = () => {
      clearInterval(timerIdRef.current);
    };

    if (isPollingEnabled) {
      startPolling();
    } else {
      stopPolling();
    }

    return () => {
      stopPolling();
    };
  }, [isPollingEnabled, query, retryInterval, retry]);

  return {
    isLoading: isPollingEnabled,
    result,
  };
};

export default usePolling;
